








































































import {
  Vue, Component,
} from 'vue-property-decorator';
import AddDispensary from '@/components/brand/RegisterBrandStepThree.vue';
import dispensaryModule from '../../store/modules/dispensary.module';
import brandModule from '../../store/modules/brand.module';
import Dispensary from '../../common/model/Dispensary';
import { eventBus } from '../../main';
import {
  DISPENSARIES_ADDED,
  SHOW_SNACKBAR,
} from '../../common/constants';
import errorModule from '../../store/modules/error.module';

@Component({
  components: {
    AddDispensary,
  },
})
export default class AdminDispensaryList extends Vue {
  brandModule = brandModule;

  addDispensaryDialog = false;

  deleteDispensaryDialog = false;

  selectedDispensary: Dispensary | undefined = undefined;

  removeDispensaryBody =
    'By removing a dispensary, you remove your brand from their Shelf. The dispensary will no longer have access to your assets and materials.';

  removeDispensaryTitle = 'Remove this Dispensary?';

  search = '';

  headers = [
    { text: 'Name', value: 'name' },
    { text: 'City', value: 'city' },
    { text: 'State', value: 'state' },
    { text: 'Address', value: 'address' },
    { text: 'License', value: 'license' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  get dispensaries() {
    return dispensaryModule.brandDispensaries;
  }

  async addDispensaryClicked() {
    await dispensaryModule.fetchDispensariesByState('California');
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    this.toggleDispensaryDialog();
  }

  toggleDispensaryDialog() {
    this.addDispensaryDialog = !this.addDispensaryDialog;
  }

  deleteDispensary(dispensary) {
    this.removeDispensaryTitle = `Remove ${dispensary.name}`;
    this.deleteDispensaryDialog = true;
    this.selectedDispensary = dispensary;
  }

  async deleteConfirmed() {
    if (!this.selectedDispensary || !brandModule.brand) {
      eventBus.$emit(SHOW_SNACKBAR, 'No dispensary selected.');
      return;
    }
    this.deleteDispensaryDialog = false;
    const brandId = brandModule.brand.id;
    await dispensaryModule.removeDispensaryFromBrand({
      brandId,
      dispensaryId: this.selectedDispensary.id,
    });
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    eventBus.$emit(
      SHOW_SNACKBAR,
      `Successfully removed ${this.selectedDispensary.name} from your brand.`,
    );
  }

  async created(): Promise<void> {
    eventBus.$on(DISPENSARIES_ADDED, this.toggleDispensaryDialog);
    if (!brandModule.brand) {
      return;
    }
    if (dispensaryModule.brandDispensaries.length === 0) {
      await dispensaryModule.fetchDispensariesForBrand(brandModule.brand.id);
      if (errorModule.hasError) {
        errorModule.clearError();
      }
    }
  }
}
